function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M13.5 10.5h9a1.5 1.5 0 110 3h-9v9a1.5 1.5 0 11-3 0v-9h-9a1.5 1.5 0 110-3h9v-9a1.5 1.5 0 113 0v9z"
});

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0zMTEuNSwxMTgyLjUgTDMyMC41LDExODIuNSBDMzIxLjMyODQyNywxMTgyLjUgMzIyLDExODMuMTcxNTcgMzIyLDExODQgQzMyMiwxMTg0LjgyODQzIDMyMS4zMjg0MjcsMTE4NS41IDMyMC41LDExODUuNSBMMzExLjUsMTE4NS41IEwzMTEuNSwxMTk0LjUgQzMxMS41LDExOTUuMzI4NDMgMzEwLjgyODQyNywxMTk2IDMxMCwxMTk2IEMzMDkuMTcxNTczLDExOTYgMzA4LjUsMTE5NS4zMjg0MyAzMDguNSwxMTk0LjUgTDMwOC41LDExODUuNSBMMjk5LjUsMTE4NS41IEMyOTguNjcxNTczLDExODUuNSAyOTgsMTE4NC44Mjg0MyAyOTgsMTE4NCBDMjk4LDExODMuMTcxNTcgMjk4LjY3MTU3MywxMTgyLjUgMjk5LjUsMTE4Mi41IEwzMDguNSwxMTgyLjUgTDMwOC41LDExNzMuNSBDMzA4LjUsMTE3Mi42NzE1NyAzMDkuMTcxNTczLDExNzIgMzEwLDExNzIgQzMxMC44Mjg0MjcsMTE3MiAzMTEuNSwxMTcyLjY3MTU3IDMxMS41LDExNzMuNSBMMzExLjUsMTE4Mi41IFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yOTggLTExNzIpIi8+Cjwvc3ZnPgo=";
export { SvgPlus as ReactComponent };